import { Controller } from '@hotwired/stimulus';
import { closeModal, isModalShown, onModalShow } from '../shared/modal/current';

// MVK-3407 — modal "Chọn khu vực" (#locationModal), thay Vue `Regions`. Nội dung là fragment Twig
// (RegionController::pickerFragment), chỉ tải khi modal MỞ lần đầu (MVK-3385: modal có trên mọi trang).
// Fragment không phụ thuộc cookie (cache shared) ⇒ tỉnh đang chọn được đánh dấu ở đây.
//
// MVK-3905 — controller dùng chung cho trang Bootstrap lẫn Flowbite, nên không biết thư viện modal nào (đi qua
// shared/modal/current.js) và không viết cứng class nào: class ẩn/hiện do markup khai trên phần tử có `data-controller`
// (`data-region-picker-hidden-class="d-none"` hoặc `="hidden"`), KHÔNG đặt trong fragment vì Stimulus chỉ đọc ở phần tử đó.
export default class extends Controller {
    // `heading`: tiêu đề nhóm tỉnh mới (MVK-3981, chỉ bản Flowbite) — ẩn khi đang tìm để kết quả liền mạch.
    static targets = ['search', 'item', 'heading'];
    static values = { url: String, modal: String };
    // `hidden`: ẩn (bắt buộc). `visible`: class phần tử mang khi hiện, nếu `hidden` đè không nổi nó (Bootstrap `d-flex`
    // là !important ⇒ phải gỡ khi ẩn). `selected`: class của dòng tỉnh đang chọn, ngoài dấu tích. Hai class sau là tuỳ chọn.
    static classes = ['hidden', 'visible', 'selected'];
    // shared/boot.js gán object `root` (cookie tỉnh, loading) trước khi đăng ký controller.
    static root = null;

    connect() {
        this.loaded = false;
        this.unsubscribe = onModalShow(this.modalValue, () => this.load());
        // Modal đã mở (hoặc đang mở dở) trước khi controller connect: sự kiện đã qua ⇒ tải ngay.
        if (isModalShown(this.modalValue)) this.load();
    }

    disconnect() {
        if (this.unsubscribe) this.unsubscribe();
    }

    async load() {
        if (this.loaded) return;
        this.loaded = true;
        try {
            const response = await fetch(this.urlValue, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            this.element.innerHTML = await response.text();
            this.markSelected();
        } catch (error) {
            // Lần mở modal sau thử lại.
            this.loaded = false;
        }
    }

    markSelected() {
        const current = Number(this.constructor.root.getRegion());
        this.itemTargets.forEach((item) => {
            const isCurrent = Number(item.dataset.regionId) === current;
            const check = item.querySelector('[data-region-picker-target="check"]');
            if (check) check.classList.toggle(this.hiddenClass, !isCurrent);
            if (this.hasSelectedClass) item.classList.toggle(this.selectedClass, isCurrent);
        });
    }

    filter() {
        const term = this.searchTarget.value.toLowerCase();
        this.itemTargets.forEach((item) => {
            const match = term === '' || item.dataset.name.includes(term) || (item.dataset.alias && item.dataset.alias.includes(term));
            item.classList.toggle(this.hiddenClass, !match);
            if (this.hasVisibleClass) item.classList.toggle(this.visibleClass, match);
        });
        this.headingTargets.forEach((heading) => heading.classList.toggle(this.hiddenClass, term !== ''));
    }

    ignore(event) {
        event.preventDefault();
    }

    choose(event) {
        event.preventDefault();
        const item = event.currentTarget;
        const root = this.constructor.root;
        const regionId = Number(item.dataset.regionId);
        if (Number(root.getRegion()) !== regionId) {
            root.setRegion(regionId);
            // MVK-3906: trang tự đổi khu vực tại chỗ (trang phim Flowbite tải lại fragment lịch chiếu) thì nghe
            // `region-picker:change` trên document và preventDefault(); không ai nghe ⇒ vẫn sang trang rạp của tỉnh như cũ.
            const change = this.dispatch('change', {
                detail: { regionId, item },
                cancelable: true,
            });
            if (!change.defaultPrevented) {
                root.loading();
                window.location = item.href;
            }
        }
        closeModal(this.modalValue);
    }
}
